import { render, staticRenderFns } from "./RegisterRKIDebtor.vue?vue&type=template&id=2328af2b&"
import script from "./RegisterRKIDebtor.vue?vue&type=script&lang=js&"
export * from "./RegisterRKIDebtor.vue?vue&type=script&lang=js&"
import style0 from "./RegisterRKIDebtor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports